import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	previousYear: {
		id: 'fuzzy-date-picker.common.year-selector.previous-year',
		defaultMessage: 'Previous year',
		description: 'Icon label to navigate to the previous year',
	},
	nextYear: {
		id: 'fuzzy-date-picker.common.year-selector.next-year',
		defaultMessage: 'Next year',
		description: 'Icon label to navigate to the next year',
	},
});
